<template>
    <div>
        <el-dialog :visible.sync="visible" center :close-on-click-modal="true" @close="handleClose"
      custom-class="dialog_normalsuo  " :append-to-body="true">
      <div>
         <div class="detail_cont">
      <div class="flex_center margin-bottom20"><img style="width: 5rem;height: 4.57143rem;" src="../../assets/dialogIcoImg/noPoweIcon.png" alt=""></div>
                    <h3>Operation Warning</h3>
          <div class="detail_cont_text" style="margin-top: 0px !important;">
      The system has found that you have engaged in abuse, crawling, and other situations. The system will notify the customer as soon as possible to resolve the issue
          </div>

        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export" @click="handleClose()">{{ $t('dialog.buttton.close') }}</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>

export default {
  
    data() {
        return {
            visible:false,
            //page: this.currentPage

            token: sessionStorage.getItem('token'),
        };
    },
    computed: {
        newDialog: {
            get() {
                return this.suoClose;
            },
            set() { },
        },

    },
    created() {
        
        this.$bus.$on('show-OperationWaring-dialog', (on)=>{
            this.showDialog()
        });
    },
    beforeDestroy() {
        this.$bus.$off('show-OperationWaring-dialog', this.showDialog);
    },
    methods: {
        handleClose(value){
            this.visible = false;
        },
        showDialog(value){ 

            this.visible = true;
        },
        //关闭弹窗
   
   
    },
      
};
</script>
<style scoped>
.detail_cont {
    max-height: 85vh;
    overflow: auto;

}


</style>
